module.exports = __webpack_public_path__ + "img/Gord.aba969f7.jpg";